module.exports = __webpack_public_path__ + "img/17.aedab540.jpg";